import { ApiResponse } from '../types/api';
import { adminApi } from './base';

type GetBannerParams = {
  product: string;
  page: string;
  isAffiliate: boolean;
  countryCode: string;
  agentCode: string;
};

export type Banner = {
  id: number;
  product: string;
  title: string;
  page: string;
  content: string;
  url: string;
  position: number;
  isAffiliateBanner: boolean;
  agentCode: string;
  startDate: string; // ISO string
  endDate: string; // ISO string
  created: string; // ISO string
  tncDoc: string;
};

export type GetBannerResponse = ApiResponse<Banner[]>;

export const bannerApi = adminApi.injectEndpoints({
  endpoints: (builder) => ({
    getBanner: builder.query<GetBannerResponse, GetBannerParams>({
      query: ({ product, page, isAffiliate, countryCode, agentCode }) => ({
        url: '/?relativeUrl=MY/BannerConfig/GetBanner/',
        method: 'POST',
        body: {
          product,
          page,
          countryCode,
          isAffiliate,
          agentCode,
        },
      }),
    }),
  }),
});

export const { useGetBannerQuery, useLazyGetBannerQuery } = bannerApi;
